import { render } from "./TotalEmployees.vue?vue&type=template&id=5a1f6589"
import script from "./TotalEmployees.vue?vue&type=script&lang=js"
export * from "./TotalEmployees.vue?vue&type=script&lang=js"

import "./TotalEmployees.vue?vue&type=style&index=0&id=5a1f6589&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__